// @flow
import React from 'react';
import { format } from 'date-fns';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import FlightCard from './FlightCard';
import { WhitePanel } from '../../../../components';
import { isMobile, getTotalHoneyguideCredit } from '../../helpers';
import { BookFlightsButton, injectFlightSearchParams } from '../../Common';

const departureOnlyMessage = 'SELECT YOUR DEPARTING FLIGHT';
const departureArrivalMessage =
  'SELECT YOUR DEPARTING FLIGHT and SELECT YOUR RETURNING FLIGHT';

function SearchResults(props) {
  const {
    inbound,
    outbound,
    queryParams: { departureDate, arrivalDate },
    isOneWay,
    isRoundTrip,
    sectionId,
    alternativeResults,
  } = props;

  const [selectedInboundId, setSelectedInboundId] = React.useState(null);
  const [selectedOutboundId, setSelectedOutboundId] = React.useState(null);

  const selectedInbound = getSelectedFlight(inbound, selectedInboundId);
  const selectedOutbound = getSelectedFlight(outbound, selectedOutboundId);

  const totalHoneyguideCredit = getTotalHoneyguideCredit(
    selectedInbound,
    selectedOutbound
  );

  const userHasSelectedFlights = selectedInboundId && selectedOutboundId;
  const flightsFor = outbound && outbound[0] ? ` FOR ${fullName(outbound[0].departure)} TO ${fullName(outbound[0].arrival)}` : '';

  // Don't show anything if there are no alternative flights
  if (alternativeResults && !outbound) return null;

  return (
    <section className="flight-result">
      <WhitePanel id="flight-search-results">
        <h2 className="text-center" id={sectionId}>
          {isOneWay ? departureOnlyMessage : departureArrivalMessage}{flightsFor}
        </h2>
        <br />
        <Row>
          <Col lg={isOneWay ? '12' : '5'} xs="12">
            <TitleText
              flight={outbound}
              date={departureDate}
              headerFn={headerForDeparture}
            />
            {!isEmpty(outbound) ? (
              outbound.map(flight => (
                <FlightCard
                  key={flight.flightId}
                  flight={flight}
                  type="outbound"
                  showBookButton={isOneWay}
                  isSelected={setIsSelected(
                    flight.flightId,
                    selectedOutboundId
                  )}
                  onSelect={() => setSelectedOutboundId(flight.flightId)}
                />
              ))
            ) : (
              <p className="error mt-4 text-center">
                Sorry, no departing flights found. Please select another date
              </p>
            )}
          </Col>
          {isRoundTrip && (
            <Col lg="5" xs="12">
              <TitleText
                flight={inbound}
                date={arrivalDate}
                headerFn={headerForArrival}
              />
              {!isEmpty(inbound) ? (
                inbound.map(flight => (
                  <FlightCard
                    key={flight.flightId}
                    flight={flight}
                    type="inbound"
                    isSelected={setIsSelected(
                      flight.flightId,
                      selectedInboundId
                    )}
                    onSelect={() => setSelectedInboundId(flight.flightId)}
                  />
                ))
              ) : (
                <p className="error mt-4 text-center">
                  Sorry, no returning flights found. Please select another date
                </p>
              )}
            </Col>
          )}

          {userHasSelectedFlights && (
            <Col lg="2" xs="12">
              <h3 className="flight-result-title invisible">Book</h3>
              {isMobile.any() ? (
                <SideBookButton honeyguideCredit={totalHoneyguideCredit} />
              ) : (
                inbound.map(i => (
                  <SideBookButton
                    key={i.id}
                    show={
                      userHasSelectedFlights && selectedInboundId === i.flightId
                    }
                    honeyguideCredit={totalHoneyguideCredit}
                  />
                ))
              )}
            </Col>
          )}
        </Row>
      </WhitePanel>
    </section>
  );

  function SideBookButton({ show = true, ...rest }) {
    const getAmtOrZero = flight => (flight ? Number(flight.totalAmount) : 0);
    return (
      <BookFlightsButton
        show={show}
        flightId={selectedOutboundId}
        returnFlightId={selectedInboundId}
        currency={selectedInbound ? selectedInbound.currency : ''}
        totalAmount={
          getAmtOrZero(selectedInbound) + getAmtOrZero(selectedOutbound)
        }
        {...rest}
      />
    );
  }
}

function fullName(flightsFor){
  if (flightsFor === 'KTM') return "KATHMANDU";
  if (flightsFor === 'LUA') return "LUKLA";
  if (flightsFor === 'RHP') return "RAMECHHAP";
  if (flightsFor === 'PKR') return "POKHARA";
  if (flightsFor === 'JOM') return "JOMSOM";
  return flightsFor;
}

const subTextHeader = message => (flights, date) =>
  `${isEmpty(flights) ? 0 : flights.length} ${message} ${format(
    date,
    'DD MMMM YYYY'
  )}`;

const headerForDeparture = subTextHeader('DEPARTING FLIGHTS FOR');
const headerForArrival = subTextHeader('RETURNING FLIGHTS ON');

const TitleText = ({ flight, date, headerFn }) => (
  <h3 className="flight-result-title text-center">{headerFn(flight, date)}</h3>
);

const setIsSelected = (flightId, selectedFlightId) => {
  if (selectedFlightId === null) return null;

  return flightId === selectedFlightId;
};

const getSelectedFlight = (flight, selectedId) =>
  selectedId && !isEmpty(flight)
    ? flight.find(f => f.flightId === selectedId)
    : null;

const mapStateToProps = ({ flights: { inbound, outbound } }) => ({
  inbound,
  outbound,
  sectionId: 'allFlightsSearchResults',
});

export default connect(mapStateToProps)(
  injectFlightSearchParams(SearchResults)
);

const mapStateToPropsForAlternativeResults = ({ flights: { alternativeFlights: { inbound, outbound } } }) => ({
  inbound,
  outbound,
  sectionId: 'allAlternativeFlightsSearchResults',
  alternativeResults: true,
});

export const AlternativeSearchResults =  connect(mapStateToPropsForAlternativeResults)(
  injectFlightSearchParams(SearchResults)
);



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchResults/SearchResults.js